import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyHeader, StyHighlightedText } from './StyledComponents';

export type CreateEventProps = {
    user: {
        email: string;
    } | null;
};

function CreateEvent({ user }: CreateEventProps): React.ReactElement {
    const { t } = useTranslation();

    const userLabel = user?.email ?? t('common.unknown');

    return (
        <StyHeader>
            <StyHighlightedText>{userLabel}</StyHighlightedText>
            {t('budgetHistory.eventCreate')}
        </StyHeader>
    );
}
export default CreateEvent;
